import { AnestheticGasMedicationEnum } from "requests";

export const GAS_MEDICATIONS = [
  { label: "Isoflurane", value: AnestheticGasMedicationEnum.Isoflurane },
  { label: "Sevoflurane", value: AnestheticGasMedicationEnum.Sevoflurane }
];
